import includes from 'lodash/includes';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { ValidationRule, WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import {
  BANNER_WIDGET_LAYOUT_TYPE_V2,
  BANNER_WIDGET_LINK_TYPE_V2,
  BannerWidgetDetailV2,
  WidgetItemBannerItem,
} from '../../../../../types/widget';
import { validateStringLength } from '../../../../../lib/utils/form/validators';
import { formRequiredRules } from '../../../../../lib/formRules';

const linkIdList = [
  BANNER_WIDGET_LINK_TYPE_V2.BRAND,
  BANNER_WIDGET_LINK_TYPE_V2.EVENT,
  BANNER_WIDGET_LINK_TYPE_V2.PRODUCT,
  BANNER_WIDGET_LINK_TYPE_V2.REVIEW,
  BANNER_WIDGET_LINK_TYPE_V2.TAG_DETAIL_GALLERY,
  BANNER_WIDGET_LINK_TYPE_V2.TAG_DETAIL_FEED,
];

const linkUrlList = [BANNER_WIDGET_LINK_TYPE_V2.WEB, BANNER_WIDGET_LINK_TYPE_V2.CATEGORY];

type BannerWidgetFormRuleReturnType = {
  mainTitle: { rules: ValidationRule[] };
  subTitle: { rules: ValidationRule[] };
  memo: { rules: ValidationRule[] };
  widgetItemBanners: {
    rules: ValidationRule[];
    innerRules: (item: WidgetItemBannerItem) => {
      mobileImage: {
        rules: ValidationRule[];
      };
      pcImage: {
        rules: ValidationRule[];
      };
      memo: {
        rules: ValidationRule[];
      };
      link: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
      linkUrl: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
      isUseBannerTitle: {
        hideIf: boolean;
      };
      title: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
      contents: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
    };
  };
};

export const useBannerWidgetFormRules = (form: WrappedFormUtils): BannerWidgetFormRuleReturnType => {
  const { layoutType } = form.getFieldsValue(['layoutType', 'linkType']) as Pick<BannerWidgetDetailV2, 'layoutType'>;

  return {
    mainTitle: {
      rules: [{ validator: validateStringLength({ max: 20, message: '위젯 타이틀의 글자 수는 최대 20자입니다' }) }],
    },
    subTitle: {
      rules: [
        { validator: validateStringLength({ max: 20, message: '위젯 서브 타이틀의 글자 수는 최대 20자입니다.' }) },
      ],
    },
    memo: {
      rules: [{ validator: validateStringLength({ max: 1000, message: '메모는 최대 글자 수는 1,000자입니다.' }) }],
    },
    widgetItemBanners: {
      rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
      innerRules: (item: WidgetItemBannerItem) => {
        return {
          mobileImage: {
            rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
          },
          pcImage: {
            rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
          },
          memo: {
            rules: [
              formRequiredRules(true, REQUIRED_MSG),
              { validator: validateStringLength({ max: 250, message: '메모는 최대 글자 수는 250자입니다.' }) },
            ],
          },
          link: {
            hideIf: !includes(linkIdList, item.linkType),
            rules: [{ required: true, type: 'object', message: REQUIRED_MSG }],
          },
          linkUrl: {
            hideIf: !includes(linkUrlList, item.linkType),
            rules: [{ required: true, message: REQUIRED_MSG }],
          },
          isUseBannerTitle: {
            hideIf: layoutType !== BANNER_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1,
          },
          title: {
            hideIf: !item.isUseBannerTitle,
            rules: [
              formRequiredRules(true, REQUIRED_MSG),
              { validator: validateStringLength({ max: 20, message: '배너 타이틀의 글자 수는 최대 20자입니다' }) },
            ],
          },
          contents: {
            hideIf: !item.isUseBannerTitle,
            rules: [
              { validator: validateStringLength({ max: 50, message: '배너 서브 타이틀의 글자 수는 최대 50자입니다' }) },
            ],
          },
        };
      },
    },
  };
};
